import * as Yup from 'yup';

export const configurationTableValidationSchema = Yup.object().shape({
  configurationGroup: Yup.string().required(),
  tokenName: Yup.string().required(),
  value: Yup.string().required(),
  description: Yup.string(),
});
